import React from "react";
import { Button } from "ui-components";
import { NavigationWrapper } from "@common/styled/navigation";

class NavigationBar extends React.Component {
  render() {
    const {
      isRiskIndicated,
      showAppendixDialog,
      showCompletionDialog
    } = this.props;

    return (
      <NavigationWrapper>
        <Button
          key="risk_indicator"
          medium
          disabled={!isRiskIndicated}
          onClick={showAppendixDialog}
        >
          Add Actions
        </Button>
        <Button medium onClick={showCompletionDialog}>
          Complete
        </Button>
      </NavigationWrapper>
    );
  }
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/previsit/components/Content/NavigationBar/NavigationBar.jsx